import { render, staticRenderFns } from "./generate-barcodes.vue?vue&type=template&id=68c6f453"
import script from "./generate-barcodes.vue?vue&type=script&lang=js"
export * from "./generate-barcodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports